import { __ } from '@/hub-shared/utils/i18n';

const ROLE_LABELS: Record<string, string> = {
  expert_comptable: __('Expert-comptable'),
  collaborateur_comptable: __('Collaborateur'),
};

export const missionRoleLabel = (role: string): string => ROLE_LABELS[role] ?? role;
